exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\r\n  --phoneOnly:599px;\r\n  --tabletPortraitUp:600px;\r\n  --tabletLandscapeUp:900px;\r\n  --desktopUp:1200px;\r\n  --desktopBigUp:1800px;\r\n}", ""]);
